export const arrayToConstMap: (
  l: readonly string[]
) => Record<string, string> = l =>
  Object.freeze(l.reduce((a, e) => ({ ...a, [e]: e }), {}));
export const objectPick = (o: Record<string, unknown>) => (p: string[]) =>
  p.reduce((a, e) => ({ ...a, [e]: o[e] }), {});
